import Vue from 'vue'
import Vuex from 'vuex'
import {Roles} from "@/constants";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    colors: [],
    drawerOpen: false,
    droppedControl: {
      valid: false,
      dropped: {
        name: '',
      },
      on: {
        name: '',
        id: -1,
      },
    },
    loadingCount: 0,
    localization: true,  // 1 - Showing English, 0 - Showing Spanish
    menuItems: [],
    notification: {},
    notificationDisplay: false,
    pageId: 0,
    postItemsPerPage: 10,
    postSelectedPage: 1,
    postSelectedCategories: [],
    postSelectedTags: [],
    properties: [],
    registrySettings: [],
    responseError: null,
    returnUrl: '',
    settings: {},
    menu: 0,
    user: {
      email: '',
      firstName: '',
      isVerified: false,
      lastname: '',
      LoggedIn: false,
      phone: '',
      id: '',
      userName: '',
      userRoles: [],
      role: '',
      token: '',
      expires: '',
    },
    vehicleId: '',
    dark: true,
  },

  getters: {
    isAdministrator: state => {
      return state.user.userRoles.indexOf(Roles.administrator) > -1;
    },
    isManager: state => {
      return state.user.userRoles.indexOf(Roles.manager) > -1;
    },
    isBlogger: state => {
      return state.user.userRoles.indexOf(Roles.blogger) > -1;
    },
    isForeman: state => {
      return state.user.userRoles.indexOf(Roles.foreman) > -1;
    },
    isOffice: state => {
      return state.user.userRoles.indexOf(Roles.office) > -1;
    },
    getColors: state => state.colors,
    getDrawerOpen: state => state.drawerOpen,
    getDroppedControl: state => state.droppedControl,
    getLoading: state => state.loadingCount > 0,
    getLocalization: state => state.localization,
    getMenuItems: state => state.menuItems,
    getNotification: state => state.notification,
    getNotificationDisplay: state => state.notificationDisplay,
    getPageId: state => state.pageId,
    getPostSelectedPage: state => state.postSelectedPage,
    getPostItemsPerPage: state => state.postItemsPerPage,
    getPostSelectedCategories: state => state.postSelectedCategories,
    getPostSelectedTags: state => state.postSelectedTags,
    getProperties: state => state.properties,
    getUser: state => state.user,
    getUserRoles: state => state.user.userRoles,
    getRegistrySettings: state => state.registrySettings,
    getResponseError: state => state.responseError,
    getReturnUrl: state => state.returnUrl,
    getSettings: state => state.settings,
    getDark: state => state.dark,
    getToken: state => state.user.token,
    getVehicleId: state => state.vehicleId,
  },

  mutations: {

    isLoading(state) {
      state.loadingCount++
    },

    notLoading(state) {
      state.loadingCount--
    },

    // Is the Navigation Drawer open or closed
    toggleDrawer(state) {
      state.drawerOpen = !state.drawerOpen
    },

    toggleLocalization(state) {
      state.localization = !state.localization
    },

    setColor(color) {
      state => {
        state.colors[state.colors.map((x, i) => [i, x]).filter(
        x => x[1].id == color.id)[0][0]] = color

        state.commit("setColors", state.colors)
      }
    },

    setColors(state, colors) {
      state.colors = colors
    },

    setDark(state, isDark) {
      state.dark = isDark
    },

    setDroppedControl(state, control) {
      state.droppedControl = control
    },

    setMenuItems(state, menuItems) {
      state.menuItems = menuItems
    },

    setNotification(state, notification) {
      state.notification = notification
    },

    setNotificationDisplay(state, display) {
      state.notificationDisplay = display
    },

    setPageId(state, id) {
      state.pageId = id
    },
    
    setPostSelectedItemsPerPage(state, postItemsPerPage) {
      state.postItemsPerPage = postItemsPerPage
    },

    setPostSelectedPage(state, postSelectedPage) {
      state.postSelectedPage = postSelectedPage
    },

    setPostSelectedTags(state, selectedTags) {
      state.postSelectedTags = selectedTags
    },

    setPostSelectedCategories(state, selectedCategories) {
      state.postSelectedCategories = selectedCategories
    },

    setProperties(state, properties) {
      state.properties = properties
    },

    setRegistrySettings(state, settings){
      state.registrySettings = settings
    },
    
    setResponseError(state, error) {
      state.responseError = error
    },

    setReturnUrl(state, returnUrl) {
      state.returnUrl = returnUrl
    },

    setSettings(state, settings) {
      // console.log(settings);
      state.settings = settings;
    },

    setUser(state, user) {
      // // console.log("setUser", user);
      state.user = user
      state.user.isVerified = true;
      if (user.id == 0) {
        state.user.userRoles = [];
        state.user.isVerified = false;
      }
    },

    setVehicleId(state, id) {
      state.vehicleId = id;
    },

    updateMenu(state) {
      // console.log("menu:", state.menu)
      state.menu += 1;
    }
  }
})
